import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["className", "size", "alt", "width", "height", "color", "hoverColor"];
var _templateObject;
import React from 'react';
import styled from '@emotion/styled';
import { useTranslate } from '../util';
var StyledIconWrapper = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: inline-block;\n\t> svg {\n\t\tdisplay: block;\n\t\tpointer-events: none;\n\t}\n"])));
export function createIcon(displayName, content, data) {
  // svg has to be block to remove excess pixels http://stackoverflow.com/a/24626986
  // need inline-block outer span to prevent block icons by default
  var Icon = function Icon(_ref) {
    var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? null : _ref$size,
      alt = _ref.alt,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? null : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? null : _ref$height,
      color = _ref.color,
      hoverColor = _ref.hoverColor,
      spanProps = _objectWithoutProperties(_ref, _excluded);
    var t = useTranslate();
    var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
    var svgProps = {
      role: 'img'
    };
    var svgData = {};
    if (typeof data === 'string') {
      svgData.i18nKey = data;
    } else if (data) {
      svgData = data;
    }
    var svgTitle = svgData.i18nKey ? t(svgData.i18nKey) : alt;
    svgProps['aria-label'] = svgTitle;
    if (size != null) {
      svgProps.width = size;
      svgProps.height = size;
    }
    if (width) {
      svgProps.width = width;
    }
    if (height) {
      svgProps.height = height;
    }
    var currentColor = hover && hoverColor ? hoverColor : color;
    return /*#__PURE__*/React.createElement(StyledIconWrapper, _extends({}, spanProps, {
      className: className,
      onMouseEnter: function onMouseEnter() {
        return setHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setHover(false);
      }
    }), /*#__PURE__*/React.cloneElement(content(svgTitle, currentColor || undefined), svgProps));
  };
  Icon.displayName = displayName;
  return Icon;
}